import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateOffer } from '../../../../common/api/clients/order.api';
import { queries } from '../../../../common/api/queryKeys/queries';

export const useOfferUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateOffer,
        onSuccess: (data, variables) => {
            const invalidations = [
                queryClient.invalidateQueries({ queryKey: queries.offers.detail(data.id).queryKey }),
                queryClient.invalidateQueries({
                    queryKey: queries.requestsForQuotes.detail(data.requestForQuoteId).queryKey,
                }),
            ];

            if (variables.offer?.orderId) {
                invalidations.push(
                    queryClient.invalidateQueries({
                        queryKey: queries.offers.list({ orderIds: [variables.offer.orderId] }).queryKey,
                    })
                );
            }

            return Promise.all(invalidations);
        },
    });
};
